export class RepresentanteOptions {
    canImportar: boolean;
    canImportErp_v1: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.canImportar ||
                this.canImportErp_v1;
    }
}
